<!-- 充值管理 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container recharge-manage">
      <el-form size="small" :inline="true" :model="listQuery" >
        <!-- 申请日期 -->
        <el-form-item :label="$t('Common.applicationDate') + ':'" >
          <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              style="width: 130px;"
              value-format="yyyy-MM-dd"
              placeholder=""
          />&nbsp;&nbsp; - &nbsp;&nbsp;
          <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              style="width: 130px;"
              value-format="yyyy-MM-dd"
              placeholder=""
          />
        </el-form-item>
        <!-- 状态 -->
        <el-form-item :label="$t('fiBankbookTemp.status') + ':'">
          <el-select v-model="listQuery.status" placeholder="" clearable>
            <el-option value="" />
            <el-option v-for="item in statusList" :key="item.code" :label="$lt(initDict.status, item.code)" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
        <el-button :loading="btnLoading" size="small" type="success" icon="el-icon-plus" @click="addBtn">{{ $t('fi.wycz') }}</el-button>
      </el-form >
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column :label="$t('sysOperationLog.moduleName')" width="60" header-align="center" align="center">
          <template v-slot="{row}">
            <el-button circle size="mini" icon="el-icon-search" :title="$t('button.view')" @click="viewTableBtn(row)" />
          </template>
        </el-table-column>
        <!-- 支付金额 -->
        <el-table-column :label="$t('busi.pay.amount')" prop="localMoney" align="center"/>
        <!-- 币种 -->
        <el-table-column :label="$t('fiShopAcTemp.currencyCode')" prop="localCurrency" align="center"/>
        <!-- 汇率 -->
        <el-table-column :label="$t('alCurrency.rate')" prop="rate" align="center"/>
        <!-- 充值金额 -->
        <el-table-column :label="$t('fi.czje')" prop="money" align="center"/>
        <!-- 充值方式 -->
        <el-table-column :label="$t('fiBankbookTempRecharge.moneyType')" align="center">
          <template v-slot="{row}">
            {{ $lt('trans_type_cn', row.tranType) }}
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column :label="$t('Common.status')" align="center">
          <template v-slot="{row}">
            {{ $lt('fi_ac_input_status_cn', row.status) }}
          </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column :label="$t('poReturn.createRemark')" prop="remark" align="center"/>
        <!-- 申请日期 -->
        <el-table-column :label="$t('Common.applicationDate')" prop="createTime" align="center"/>
        <!-- 入账时间 -->
        <el-table-column :label="$t('fi.credit.time')" prop="recheckeTime" align="center"/>
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"
import {getFiAcInputs} from '@/api/ay-account-manager'

export default {
  name: 'RechargeManage',
  components: { Pagination },
  data() {
    return {
      btnLoading: false,
      tableLoading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      initDict: {
        status: 'fi_ac_input_status_cn'
      }
    }
  },
  computed: {
    statusList() {
      return this.$ll(this.initDict.status)
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.tableLoading = true
      this.btnLoading = true
      getFiAcInputs({ ...this.listQuery}).then(res => {
        this.list = res.data.records
        this.total = +res.data.total || 0
        this.btnLoading = false
        this.tableLoading = false
      }).catch(err => {
        console.warn(err)
        this.btnLoading = false
        this.tableLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    addBtn() {
      this.$router.push({name: 'AccountRecharge'})
    },
    viewTableBtn(row) {
      this.$router.push({ name: 'ViewRecharge', params:{ id: row.id } })
    }
  }
}
</script>

<style scoped>

</style>
